import { render, staticRenderFns } from "./paperSubject.vue?vue&type=template&id=7c85d598&scoped=true"
import script from "./paperSubject.vue?vue&type=script&lang=js"
export * from "./paperSubject.vue?vue&type=script&lang=js"
import style0 from "./paperSubject.vue?vue&type=style&index=0&id=7c85d598&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85d598",
  null
  
)

export default component.exports